<div [ngClass]="getStatusClass()" [style.border-color]="getMachineStatusColor()" class="machine-status flex-row flex-center">
  <mat-icon [svgIcon]="getIconNameForMachineType()"></mat-icon>
</div>
